module.exports = __webpack_public_path__ + "img/shiba888-ic-mobile-right-2.db543823.png";